import React, { useContext, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import MyInput from "../../../Reusable/MyInput";
import Button from "../../../Reusable/Button";
import DivisionPageForm from "../../../masterFormPages/DivisionPageForm";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import CreateUserPageForm from "./CreateUserPageForm";
import MyTextarea from "../../../Reusable/MyTextarea";
import { UserRoleSelect } from "./UserRoleSelect";
import { GoEye } from "react-icons/go";
import { GoEyeClosed } from "react-icons/go";
import CreateUserPermissPageForm from "./CreateUserPermissPageForm";

export default function CreateUser() {
  const { darkTheme, loginData } = useContext(UserContext);
  const [divisionName, setDivisionName] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [pwdConfirmation, setPwdConfirmation] = useState("");
  const [roleId, setRoleId] = useState("");
  const [roleIdTarget, setRoleIdTarget] = useState("");
  const [inpTypeTogg, setInpTypeTogg] = useState("password");
  const [inpTypeToggSec, setInpTypeToggSec] = useState("password");
  const [changingSelect, setChangingSelect] = useState(false);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [permisList, setPermisList] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);
  const [permisBtnDisable, setPermisBtnDisable] = useState(false);

  // create Division
  async function createDivision(e) {
    e.preventDefault();
    if (password === pwdConfirmation && password.length >= 8) {
      // const formData = new FormData();
      // formData.append("name", divisionName);
      setSubmitDisable(true);
      const formData = {
        name: name || "",
        phone: phone || "",
        email: email || "",
        address: address || "",
        username: username || "",
        password: password || "",
        role_id: roleId?.value,
        password_confirmation: pwdConfirmation || "",
      };

      const res = await fetch(`${BaseURL}/register`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          // Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resdata) => resdata.json())
        .then((createRes) => {
          if (createRes.status) {
            firstPageList();
            setGetId(0);
            toast.success("Success");
            // setDivisionName("");
            setName("");
            setPhone("");
            setEmail("");
            setAddress("");
            setUsername("");
            setPassword("");
            setPwdConfirmation("");
            setRoleId("");
            setSubmitDisable(false);
          }
          if (createRes.status === false) {
            setSubmitDisable(false);
          }
          if (createRes?.error?.message.name) {
            toast.error(createRes.error.message.name);
          } else if (createRes?.error?.message.phone) {
            toast.error(createRes.error.message.phone);
          } else if (createRes?.error?.message.role_id) {
            toast.error(createRes.error.message.role_id);
          } else if (createRes?.error?.message.username) {
            toast.error(createRes.error.message.username);
          } else if (createRes?.error?.message.password) {
            toast.error(createRes.error.message.password);
          } else if (createRes?.error?.message) {
            toast.error("Some Issue !");
          }
        });
    } else {
      toast.error("Password is not matched & min 8 Char.");
    }
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/userlist`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((divisionList) => {
        if (divisionList?.status) {
          const revData = divisionList.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(divisionList.data.total);
          setLinks(divisionList.data.links);
          setFrom(divisionList.data.from);
          setTo(divisionList.data.to);
          setSpinner(false);
        }
      });
  }

  function editBtn(id) {
    fetch(`${BaseURL}/userinfo/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setSubmitAction("update");

          setPassword("");
          setPwdConfirmation("");
          setUsername("")
          // setRoleId(editData.data.role_id);

          setName(selectedRecord?.data?.name || "");
          setPhone(selectedRecord?.data?.phone || "");
          setEmail(selectedRecord?.data?.email || "");
          setAddress(selectedRecord?.data?.address || "");
          setUsername(selectedRecord?.data?.username || "");

          setRoleIdTarget(selectedRecord?.data?.role_id);

          // TOP SCROLLING ==========
          // const scrollToTop = () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth", // You can use 'auto' instead of 'smooth' for instant scrolling
          });
          // };
          toast.success("Go to update form");
        }
      });
    setChangingSelect(false);
  }
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    if (password === pwdConfirmation) {
      setUpdateDisable(true);
      const formData = {
        name: name || "",
        phone: phone || "",
        email: email || "",
        address: address || "",
        username: username || "",
        // password: password || "",
        // password_confirmation: pwdConfirmation || "",
        role_id: roleId?.value,
      };
      const updRes = await fetch(`${BaseURL}/updateuser/${id}`, {
        method: "PATCH",
        body: JSON.stringify(formData),
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify({name: divisionName}),
      })
        .then((res) => res.json())
        .then((upd) => {
          if (upd.status) {
            firstPageList();
            setGetId(0);
            setName("");
            setPhone("");
            setEmail("");
            setAddress("");
            setUsername("");
            setPassword("");
            setPwdConfirmation("");
            setRoleId("");
            toast.success("Updated");
            setSubmitAction("submit");
            setUpdateDisable(false);
          }
          if (upd.status === false) {
            setUpdateDisable(false);
          }
          if (upd?.error?.message.name) {
            toast.error(upd.error.message.name);
          } else if (upd?.error?.message.phone) {
            toast.error(upd.error.message.phone);
          } else if (upd?.error?.message.role_id) {
            toast.error(upd.error.message.role_id);
          } else if (upd?.error?.message.username) {
            toast.error(upd.error.message.username);
          } else if (upd?.error?.message.password) {
            toast.error(upd.error.message.password);
          } else if (upd?.error?.message) {
            toast.error("Some Issue !");
          }
        });
    } else {
      toast.error("Password is not matched");
    }
  }

  function cancelFun() {
    setSubmitAction("submit");
    // setDivisionName("");
    setName("");
    setPhone("");
    setEmail("");
    setAddress("");
    setUsername("");
    setPassword("");
    setPwdConfirmation("");
    setRoleId("");
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setEditDisable(false);
  }

  const setPwdToggleFun = () => {
    const toggle = inpTypeTogg === "text" ? "password" : "text";
    setInpTypeTogg(toggle);
  };
  const setPwdToggleFunSec = () => {
    const toggle = inpTypeToggSec === "text" ? "password" : "text";
    setInpTypeToggSec(toggle);
  };

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Create User
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col justify-between gap-8 md:gap-1 lg:gap-4"
          >
            <div className="w-full px-2">
              <form
                action=""
                className="grid grid-cols-2 md:grid-cols-4 gap-1 md:gap-3"
              >
                <MyInput
                  label="Name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full"
                  mendatory="*"
                />
                <MyInput
                  label="Phone"
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full"
                  mendatory="*"
                />
                <MyInput
                  label="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full normal-case"
                  // mendatory="*"
                />
                <MyTextarea
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  label="Address"
                  type="text"
                  className="w-full"
                  // mendatory="*"
                />
                {submitAction === "submit" && <MyInput
                  label="Username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full"
                  mendatory="*"
                />}
                {submitAction === "submit" && (
                  <div>
                    <label>Password</label>{" "}
                    <span className="text-red-500 font-bold">*</span>
                    <div className="flex items-center relative">
                      <MyInput
                        // label="Password"
                        type={inpTypeTogg}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full absolute left-0 right-0 normal-case"
                        mendatory="*"
                      />

                      {password && (
                        <button
                          type="button"
                          className="absolute z-0 top-[10px] right-2"
                          onClick={() => setPwdToggleFun()}
                        >
                          {inpTypeTogg === "text" ? (
                            <GoEyeClosed className="w-5 h-5 text-gray-400" />
                          ) : (
                            <GoEye className="w-5 h-5 text-gray-400" />
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                )}
                {submitAction === "submit" && (
                  <div>
                    <label>Confirm Password</label>{" "}
                    <span className="text-red-500 font-bold">*</span>
                    <div className="flex items-center relative">
                      <MyInput
                        // label="Confirm Password"
                        type={inpTypeToggSec}
                        value={pwdConfirmation}
                        onChange={(e) => setPwdConfirmation(e.target.value)}
                        className="w-full absolute left-0 right-0 normal-case"
                        mendatory="*"
                      />

                      {pwdConfirmation && (
                        <button
                          type="button"
                          className="absolute z-0 top-[10px] right-2"
                          onClick={() => setPwdToggleFunSec()}
                        >
                          {inpTypeToggSec === "text" ? (
                            <GoEyeClosed className="w-5 h-5 text-gray-400" />
                          ) : (
                            <GoEye className="w-5 h-5 text-gray-400" />
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                )}
                <div className="mb-2">
                  <label>
                    User Role <span className="text-red-500 font-bold">*</span>
                  </label>
                  <UserRoleSelect
                    selectedOption={roleId}
                    setSelectedOption={setRoleId}
                    changingSelect={changingSelect}
                    setChangingSelect={setChangingSelect}
                    roleIdTarget={roleIdTarget}
                  />
                </div>
              </form>
            </div>
            {submitAction === "submit" && (
              <div className="flex items-center justify-center gap-x-1">
                <Button
                  disabled={submitDisable}
                  type="submit"
                  onClick={(e) => createDivision(e)}
                >
                  {submitDisable ? "Wait.." : "Submit"}
                </Button>
                <Button type="button" onClick={() => cancelFun()}>
                  Clear
                </Button>
              </div>
            )}
            {submitAction === "update" && (
              <div className="flex items-center justify-center gap-x-1">
                <Button
                  disabled={updateDisable}
                  type="submit"
                  onClick={(e) => updateARecord(e, getId)}
                >
                  {updateDisable ? "Wait.." : "Update"}
                </Button>
                <Button onClick={() => cancelFun()} type="button">
                  Cancel
                </Button>
              </div>
            )}

            <div className="w-full px-2 mt-2">
              <CreateUserPageForm
                editBtn={editBtn}
                firstPageList={firstPageList}
                links={links}
                firstPage={firstPage}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                editDisable={editDisable}
                permisBtnDisable={permisBtnDisable}
                setPermisBtnDisable={setPermisBtnDisable}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
